export const FarmIcon = (props) => (
  <svg viewBox="0 0 42 42" {...props} fill={props.color} height={`${props.size || 42}`} width={`${props.size || 42}`}>
    <g>
      <polygon fill="none" stroke={props.color} points="26.7,18.7 26.7,26.7 15.3,26.7 15.3,18.7 21,15.3 	" />
      <line fill="none" stroke={props.color} x1="21" y1="26.5" x2="21" y2="21" />
    </g>
  </svg>
);
